export const PUBLISHED_MESSAGE_QUERY = `
{
  publishedMessage {
    id
    content
    publishedAt
  }
}
`

export const PUBLISH_MESSAGE_MUTATION = `
mutation PublishMessage($content: String!) {
  messagePublish(content: $content) {
    result {
      id
      content
      publishedAt
    }
    errors
  }
}
`

export const UPDATE_MESSAGE_MUTATION = `
mutation UpdateMessage($id: Int!, $content: String!) {
  messageUpdate(id: $id, content: $content) {
    result {
      id
      content
      publishedAt
    }
    errors
  }
}
`

export const ARCHIVE_MESSAGE_MUTATION = `
mutation ArchiveMessage($id: Int!) {
  messageArchive(id: $id) {
    result {
      id
      archivedAt
    }
    errors
  }
}
`
